module.exports = __webpack_public_path__ + "img/4.f78356d3.jpg";